<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: value => ['deal_open', 'deal_won', 'deal_lost'].includes(value),
  },
  size: {
    type: String,
    default: 'md',
    validator: value => ['sm', 'md', 'lg'].includes(value),
  },
});

const { t } = useI18n();

const statusConfig = computed(() => {
  switch (props.status) {
    case 'deal_won':
      return {
        label: t('CRM.DEAL.STATUS.WON'),
        bgClass: 'bg-green-100 dark:bg-green-900/30',
        textClass: 'text-green-700 dark:text-green-400',
        icon: 'checkmark-circle',
      };
    case 'deal_lost':
      return {
        label: t('CRM.DEAL.STATUS.LOST'),
        bgClass: 'bg-red-100 dark:bg-red-900/30',
        textClass: 'text-red-700 dark:text-red-400',
        icon: 'dismiss-circle',
      };
    default:
      return {
        label: t('CRM.DEAL.STATUS.OPEN'),
        bgClass: 'bg-woot-100 dark:bg-woot-900/30',
        textClass: 'text-woot-700 dark:text-woot-400',
        icon: 'clock',
      };
  }
});

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'px-1.5 py-0.5 text-xs';
    case 'lg':
      return 'px-3 py-1.5 text-sm';
    default:
      return 'px-2 py-1 text-xs';
  }
});
</script>

<template>
  <span
    class="deal-status-badge inline-flex items-center gap-1 font-medium rounded-full"
    :class="[statusConfig.bgClass, statusConfig.textClass, sizeClasses]"
  >
    <fluent-icon :icon="statusConfig.icon" :size="size === 'lg' ? 16 : 12" />
    {{ statusConfig.label }}
  </span>
</template>
